import "./styles.less";

import { Button, Empty, Typography } from "antd";

import { GoogleMap } from "../../Map/GoogleMap/web";
import { ImagenOptimizada } from "../../Image/web";
import React from "react";
import getConfig from "next/config";
import { usePropertyMap } from "../PropertyMap/hook";
import { useTheme } from "../../../Styles/ThemeHook";

const { googleMapsApiKey } = getConfig().publicRuntimeConfig;
const { Text } = Typography;

export function PropertyStreetView({ id, width, height, mode, latitude, longitude, isProject }) {
	const handleClickShowNotification = async ({
		type = 'success',
		message = '',
		description = '',
	}) => {
		const { showNotification } = await import("shared-components/Components/CustomNotification/web");
		showNotification(
			type,
			message,
			description
		);
	}
	const { loadingSendLead, sendLead } = usePropertyMap({
		id,
		mode,
		isProject,
	});
	const { theme } = useTheme();

	if (!latitude || !longitude)
		return (
			<Empty
				imageStyle={{ height: 50, opacity: 0.9 }}
				description={
					<Text style={{ color: theme.colors.textInverseColor }}>
						{"La propiedad no tiene ubicación"}
					</Text>
				}>
				<Button
					loading={loadingSendLead}
					onClick={() =>
						sendLead().then(response => {
							handleClickShowNotification({
								message: response.success
									? "Consulta enviada"
									: "Error al enviar la consulta",
								type: response.success ? "success" : "error",
							});
						})
					}
					ghost>
					{"Pedir ubicación"}
				</Button>
			</Empty>
		);

	return (
		<>
			<div style={{ width: width, height: height, display: "flex" }}>
				<GoogleMap streetView={true} center={{ latitude, longitude }} />
			</div>
		</>
	);
}

export function PropertyStreetViewStatic({
	size = "small",
	onClick = false,
	latitude,
	longitude,
}: {
	size?: "small" | "big";
	onClick: CallableFunction | false;
	latitude: number | null;
	longitude: number | null;
}) {
	if (!latitude || !longitude) {
		return null;
	}

	const url = `https://maps.googleapis.com/maps/api/streetview?size=${size == "big" ? 640 : 320
		}x${size == "big" ? 640 : 320
		}&location=${latitude},${longitude}&fov=80&heading=70&pitch=0&key=${googleMapsApiKey}`;

	return (
		<>
			<div className="static-street-view" onClick={x => !!onClick && onClick(x)}>
				<ImagenOptimizada src={url} alt="Map" />
			</div>
			<style jsx>{`
				.static-street-view {
					cursor: ${!!onClick ? "pointer" : "default"};
				}
			`}</style>
		</>
	);
}

export async function hasStreetView({
	latitude,
	longitude,
}: {
	latitude: number | null;
	longitude: number | null;
}) {
	if (!latitude || !longitude) {
		return false;
	}

	try {
		const url = `https://maps.googleapis.com/maps/api/streetview/metadata?size=320x320&location=${latitude},${longitude}&fov=80&heading=70&pitch=0&key=${googleMapsApiKey}`;
		const response = await fetch(url);
		const json = await response.json();
		return json.status === "OK";
	} catch (error) {
		console.error("Error:", error);
		return false;
	}
}
